import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "METRICS_FORM", {
  NAME_OF_FILE: "Name of the file selected",
  RESET: "Reset",
  CREATE: "Create campaign",
});
